import { CommonModule } from '@angular/common';
import { Component, effect, inject } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { AuthStore } from '@app/stores/auth.store';
import { ValidatedCheckboxComponent } from '@app/ui-components/validated-checkbox/validated-checkbox.component';
import { ValidatedInputComponent } from '@app/ui-components/validated-input/validated-input.component';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from 'src/app/+services/auth.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    ValidatedInputComponent,
    ValidatedCheckboxComponent,
  ],
  providers: [AuthService],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  loginForm: FormGroup;
  errorMessage: string = '';
  loading: boolean = false;

  protected store = inject(AuthStore);

  constructor(private fb: FormBuilder, private router: Router) {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
      rememberMe: [false],
    });

    // a session restore completes while the user is on the login page (F5 while logged in → Angular lands on /auth/login briefly), redirect  once isLoggedIn becomes true.
    effect(() => {
      if (!this.store.isLoading() && this.store.isLoggedIn()) {
        const returnUrl =
          this.router.parseUrl(this.router.url).queryParams['returnUrl'] ||
          '/profile';
        this.router.navigateByUrl(returnUrl);
      }
    });
  }

  ngOnInit(): void {
    if (this.store.isLoggedIn()) {
      const returnUrl =
        this.router.parseUrl(this.router.url).queryParams['returnUrl'] ||
        '/profile';
      this.router.navigateByUrl(returnUrl);
    }
  }

  get email() {
    return this.loginForm.get('email');
  }

  get password() {
    return this.loginForm.get('password');
  }

  get rememberMe() {
    return this.loginForm.get('rememberMe');
  }

  onSubmit(): void {
    if (this.loginForm.invalid) {
      return;
    }

    this.loading = true;
    this.errorMessage = '';

    const credentials = {
      email: this.email?.value,
      password: this.password?.value,
    };

    this.store.login(credentials, this.rememberMe?.value).subscribe(() => {
      const returnUrl =
        this.router.parseUrl(this.router.url).queryParams['returnUrl'] ||
        '/profile';
      this.router.navigateByUrl(returnUrl);
    });
  }
}
